import React, { useState, useEffect } from "react";
import { Box, Grid2 } from "@mui/material";
import LessonList from "./LessonList";
import { axiosClient } from "../api/proxy/AxiosClient";
import ViewEditLesson from "./ViewEditLesson";
import ActionButtonsPane from "./ActionButtonsPane";
import { useLessonActions } from "../hooks/useLessonActions";
import ConfirmationDialog from "./ConfirmationDialog";

const TeacherLessons = () => {
  
  const [confirmState, setConfirmState] = useState({
    open: false,
    message: "",
    onConfirm: null,
  });
  
  const confirm = (message, onConfirm) => {
    setConfirmState({
      open: true,
      message,
      onConfirm,
    });
  };
  
  const handleCloseConfirm = () => {
    setConfirmState({ open: false, message: "", onConfirm: null });
  };

  const [mode, setMode] = useState("view");//empty, create, edit
  const [selectedLesson, setSelectedLesson] = useState(null);
  const [students, setStudents] = useState([]);
  const [lessons, setLessons] = useState([]);

  const user = JSON.parse(localStorage.getItem("user"));

  const {
    basicActions,
    createLesson,
    editLesson,
    rescheduleLesson,
  } = useLessonActions(
    "teacher",
    setLessons,
    selectedLesson,
    setSelectedLesson,
    mode,
    setMode,
    confirm,
    user?.isDemo
  );

  const sortLessons = (lessons) => {
    return lessons.sort((a, b) => new Date(b.startDttm) - new Date(a.startDttm));
  }

  const onViewEditClose = () => {
    setSelectedLesson(null);
    setMode("view");
  }

  useEffect(() => {
    axiosClient
      .get("/teachers/students")
      .then((res) => setStudents(res.data))
      .catch((err) => console.error("Error fetching students", err));
    axiosClient
      .get(`/lessons?teacherUid=${user.uid}`)
      .then((res) => setLessons(sortLessons(res.data)))
      .catch((err) => console.error("Error fetching lessons", err));
  }, [user.uid]);

  useEffect(() => {
    if (selectedLesson) {
      setMode("view");
    }
  }, [selectedLesson]);

  return (
    <Box p={3}>
      <Grid2 container spacing={2} justifyContent="center">
        <LessonList
          lessons={lessons}
          selectedLesson={selectedLesson}
          setSelectedLesson={setSelectedLesson}
          handleSelectedLesson={setSelectedLesson}
        />

        <Grid2>
          <ViewEditLesson
            lessons={lessons}
            lesson={selectedLesson}
            mode={mode}
            onClose={onViewEditClose}
            onSubmit={createLesson}
            onSave={editLesson}
            onReschedule={rescheduleLesson}
            students={students}
          />
        </Grid2>

        <ActionButtonsPane
          actions={basicActions}
        />

        <ConfirmationDialog
          open={confirmState.open}
          message={confirmState.message}
          onClose={handleCloseConfirm}
          onConfirm={async () => {
            await confirmState.onConfirm?.();
            handleCloseConfirm();
          }}
          confirmText="Yes"
          cancelText="No"
        />

      </Grid2>
    </Box>
  );
};

export default TeacherLessons;
